import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StartFunctionRequestModel } from '../model/startFunctionRequestModel';
import { StorageService } from '../shared/security/StorageService';
import { StartFunctionResponseModel } from '../model/startFunctionResponseModel';
import { environment } from '../../environments/environment';
import { ViewIndividualPendingTransactionsRequestModel } from '../model/viewIndividualPendingTransactionsRequestModel';
import { ViewIndividualPendingTransactionsResponseModel } from '../model/viewIndividualPendingTransactionsResponseModel';
import { SearchTransactionHistoryRequestModel } from '../model/searchTransactionHistoryRequestModel';
import { SearchTransactionHistoryResponseModel } from '../model/searchTransactionHistoryResponseModel';

@Injectable()
export class TransactionsService {

  public notifyIndividualPendingTransactions : EventEmitter<ViewIndividualPendingTransactionsResponseModel> = new EventEmitter<ViewIndividualPendingTransactionsResponseModel>();
  public notifyTransactionIndividualHistoryModel : EventEmitter<SearchTransactionHistoryRequestModel> = new EventEmitter<SearchTransactionHistoryRequestModel>();
  public notifyTransactionBrokerHistoryModel : EventEmitter<SearchTransactionHistoryRequestModel> = new EventEmitter<SearchTransactionHistoryRequestModel>();
  
  public notifyTransactionsError : EventEmitter<string> = new EventEmitter<string>();

  transactionHistoryRequestModel = new SearchTransactionHistoryRequestModel();

  constructor(private http : HttpClient, 
    private storage: StorageService) { }

  getIndividualPendingTransactions(individualPendingTransactionsRequestModel :ViewIndividualPendingTransactionsRequestModel){
     return this.http.post<ViewIndividualPendingTransactionsResponseModel>(environment.server_url+"/api/IndividualPendingTransactions",individualPendingTransactionsRequestModel);
     
    }

  getIndividualTransactionHistory(individualHistoryTransactionsRequestModel :SearchTransactionHistoryRequestModel){
    return this.http.post<SearchTransactionHistoryResponseModel>(environment.server_url+"/api/IndividualTransactionHistory",individualHistoryTransactionsRequestModel);
  }

  getBrokerTransactionHistory(brokerHistoryTransactionsRequestModel :SearchTransactionHistoryRequestModel){
    return this.http.post<SearchTransactionHistoryResponseModel>(environment.server_url+"/api/BrokerTransactionHistory",brokerHistoryTransactionsRequestModel);
  }

  getFunctionId(userSessionId: number , functionType: any){
    let startFunctionRequestModel =  new StartFunctionRequestModel ;
    startFunctionRequestModel.SessionID=userSessionId;
    startFunctionRequestModel.FunctionType=functionType;
    return this.http.post<StartFunctionResponseModel>(environment.server_url+"/api/StartFunction",startFunctionRequestModel);
   
  }
}



// WEBPACK FOOTER //
// ./src/app/transactions/transactions.service.ts